/* eslint-disable no-unused-vars */
import React, { useState, useCallback, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";

const CardsComponent = () => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
        align: "start",
        breakpoints: {
            992: { dragFree: true },
        },
    });

    const [scrollProgress, setScrollProgress] = useState(0);

    const onScroll = useCallback((emblaApi) => {
        const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
        setScrollProgress(progress * 100);
    }, []);

    useEffect(() => {
        if (!emblaApi) return;

        onScroll(emblaApi);

        emblaApi
            .on("reInit", onScroll)
            .on("scroll", onScroll)
            .on("slideFocus", onScroll);
    }, [emblaApi, onScroll]);

    return (
        <div ref={emblaRef} className="overflow-hidden">
            <div className="flex gap-[15px] md:gap-[30px]">
                <div className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1">
                    <div className="flex flex-col items-start gap-y-[10px]">
                        <svg
                            width="20"
                            height="16"
                            viewBox="0 0 20 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1.5 0H11.5C12.3125 0 13 0.6875 13 1.5V3H14.5625C15.0938 3 15.625 3.21875 16 3.59375L18.4062 6C18.7812 6.375 19 6.90625 19 7.4375V8V9V11C19.5312 11 20 11.4688 20 12C20 12.5625 19.5312 13 19 13H18C18 14.6562 16.6562 16 15 16C13.3438 16 12 14.6562 12 13H8C8 14.6562 6.65625 16 5 16C3.34375 16 2 14.6562 2 13H1.5C0.65625 13 0 12.3438 0 11.5V1.5C0 0.6875 0.65625 0 1.5 0ZM13 5V8H17V7.4375L14.5625 5H13ZM3.5 13C3.5 13.5625 3.78125 14.0312 4.25 14.3125C4.6875 14.5938 5.28125 14.5938 5.75 14.3125C6.1875 14.0312 6.5 13.5625 6.5 13C6.5 12.4688 6.1875 12 5.75 11.7188C5.28125 11.4375 4.6875 11.4375 4.25 11.7188C3.78125 12 3.5 12.4688 3.5 13ZM15 11.5C14.4375 11.5 13.9688 11.8125 13.6875 12.25C13.4062 12.7188 13.4062 13.3125 13.6875 13.75C13.9688 14.2188 14.4375 14.5 15 14.5C15.5312 14.5 16 14.2188 16.2812 13.75C16.5625 13.3125 16.5625 12.7188 16.2812 12.25C16 11.8125 15.5312 11.5 15 11.5Z"
                                fill="#222222"
                            />
                        </svg>

                        <div className="flex flex-col gap-[5px]">
                            <p className="!mb-0 font-extrabold">
                                Free Standard Delivery
                            </p>
                            <p className="!mb-0">
                                Enjoy free shipping on all purchases over £100.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1">
                    <div className="flex flex-col items-start gap-y-[10px]">
                        <svg
                            width="17"
                            height="16"
                            viewBox="0 0 17 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11.5 8C11.5 8.71875 11.4375 9.375 11.375 10H5.59375C5.53125 9.375 5.5 8.71875 5.5 8C5.5 7.3125 5.53125 6.65625 5.59375 6H11.375C11.4375 6.65625 11.5 7.3125 11.5 8ZM12.375 6H16.2188C16.4062 6.65625 16.5 7.3125 16.5 8C16.5 8.71875 16.4062 9.375 16.2188 10H12.375C12.4375 9.375 12.5 8.6875 12.5 8C12.5 7.3125 12.4375 6.65625 12.375 6ZM15.9062 5H12.25C11.9375 3.03125 11.3125 1.34375 10.5312 0.28125C12.9688 0.9375 14.9688 2.6875 15.9062 5ZM11.25 5H5.71875C5.90625 3.875 6.21875 2.875 6.5625 2.0625C6.90625 1.3125 7.25 0.78125 7.625 0.4375C7.96875 0.125 8.25 0 8.5 0C8.71875 0 9 0.125 9.34375 0.4375C9.71875 0.78125 10.0625 1.3125 10.4062 2.0625C10.75 2.875 11.0625 3.875 11.25 5ZM4.71875 5H1.0625C2 2.6875 4 0.9375 6.4375 0.28125C5.65625 1.34375 5.03125 3.03125 4.71875 5ZM0.75 6H4.59375C4.53125 6.65625 4.5 7.3125 4.5 8C4.5 8.6875 4.53125 9.375 4.59375 10H0.75C0.5625 9.375 0.5 8.71875 0.5 8C0.5 7.3125 0.5625 6.65625 0.75 6ZM6.5625 13.9688C6.21875 13.1562 5.90625 12.1562 5.71875 11H11.25C11.0625 12.1562 10.75 13.1562 10.4062 13.9688C10.0625 14.7188 9.71875 15.25 9.34375 15.5938C9 15.9062 8.71875 16 8.5 16C8.25 16 7.96875 15.9062 7.625 15.5938C7.25 15.25 6.90625 14.7188 6.5625 13.9688ZM4.71875 11C5.03125 13 5.65625 14.6875 6.4375 15.75C4 15.0938 2 13.3438 1.0625 11H4.71875ZM15.9062 11C14.9688 13.3438 12.9688 15.0938 10.5312 15.75C11.3438 14.6875 11.9375 13 12.25 11H15.9062Z"
                                fill="#222222"
                            />
                        </svg>

                        <div className="flex flex-col gap-[5px]">
                            <p className="!mb-0 font-extrabold">
                                The world leader
                            </p>
                            <p className="!mb-0">
                                We&apos;re the world&apos;s largest manufacturer
                                of food waste disposers.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex flex-[0_0_240px] flex-col gap-y-[30px] rounded-[10px] bg-brand-light-grey p-[15px] md:flex-1">
                    <div className="flex flex-col items-start gap-y-[10px]">
                        <svg
                            width="17"
                            height="18"
                            viewBox="0 0 17 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2.9375 1.15625L6.1875 3.65625C6.375 3.8125 6.5 4.03125 6.5 4.25V5.9375L9.90625 9.34375C10.8125 8.90625 11.9375 9.0625 12.6875 9.8125L16.1875 13.3125C16.5938 13.6875 16.5938 14.3438 16.1875 14.7188L14.1875 16.7188C13.8125 17.125 13.1562 17.125 12.7812 16.7188L9.28125 13.2188C8.53125 12.4688 8.375 11.3125 8.84375 10.4062L5.4375 7H3.71875C3.5 7 3.28125 6.90625 3.125 6.71875L0.625 3.46875C0.40625 3.15625 0.4375 2.75 0.71875 2.46875L1.96875 1.21875C2.21875 0.96875 2.65625 0.9375 2.9375 1.15625ZM1.09375 13.4062L5.75 8.75L7.6875 10.6875C7.5 11.3438 7.53125 12.0625 7.78125 12.7188L4.09375 16.4062C3.71875 16.7812 3.15625 17 2.59375 17C1.4375 17 0.5 16.0625 0.5 14.9062C0.5 14.3438 0.71875 13.7812 1.09375 13.4062ZM16.5 5.5C16.5 7.3125 15.4375 8.875 13.9062 9.59375L13.4062 9.09375C12.5312 8.21875 11.2812 7.90625 10.1562 8.21875L7.5 5.53125V5.5C7.5 3.03125 9.5 1 12 1C12.3125 1 12.625 1.0625 12.9375 1.125C13.2812 1.1875 13.375 1.625 13.125 1.875L11.125 3.875C11.0312 3.96875 11 4.09375 11 4.21875V6C11 6.28125 11.2188 6.5 11.5 6.5L13.2812 6.53125C13.4062 6.53125 13.5312 6.46875 13.625 6.375L15.625 4.375C15.875 4.125 16.3125 4.21875 16.375 4.5625C16.4375 4.875 16.5 5.1875 16.5 5.5ZM2.25 14.5C2.25 14.9375 2.5625 15.25 3 15.25C3.40625 15.25 3.75 14.9375 3.75 14.5C3.75 14.0938 3.40625 13.75 3 13.75C2.5625 13.75 2.25 14.0938 2.25 14.5Z"
                                fill="#222222"
                            />
                        </svg>

                        <div className="flex flex-col gap-[5px]">
                            <p className="!mb-0 font-extrabold">
                                Let us fit it for you
                            </p>
                            <p className="!mb-0">
                                We can professionally fit your food waste
                                disposer or instant hot water tap.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardsComponent;
